import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
interface RouteTabsItemProps {
  includedURLPath: string;
  onClick: () => void;
  className?: string;
  isMiddleLine?: boolean;
  children: ReactNode;
}
function PageTab(t0) {
  const $ = _c(17);
  const {
    includedURLPath,
    className,
    onClick,
    isMiddleLine: t1,
    children
  } = t0;
  const isMiddleLine = t1 === undefined ? false : t1;
  const pathname = usePathname();
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== className || $[1] !== includedURLPath || $[2] !== isMiddleLine || $[3] !== onClick || $[4] !== pathname) {
    const isCurrentTab = pathname.includes(includedURLPath);
    t3 = "button";
    t4 = cn("relative h-[64px]", {
      "mx-[20px] px-[5px]": !isMiddleLine
    }, {
      "mx-[17px] px-[3px]": isMiddleLine
    }, {
      "border-t-4 border-t-transparent border-b-4 border-b-borderBg04": isCurrentTab && !isMiddleLine
    }, className);
    t5 = onClick;
    t2 = cn("whitespace-nowrap text-[18px] text-baseFg ", {
      "font-[500]": isCurrentTab && !isMiddleLine
    }, {
      "before:!h-[10px] before:!w-full before:absolute before:top-[33px] before:right-0 before:z-[-1] before:inline-block before:bg-borderBg17": isCurrentTab && isMiddleLine
    });
    $[0] = className;
    $[1] = includedURLPath;
    $[2] = isMiddleLine;
    $[3] = onClick;
    $[4] = pathname;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t2) {
    t6 = <p className={t2}>{children}</p>;
    $[9] = children;
    $[10] = t2;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <button type={t3} className={t4} onClick={t5}>{t6}</button>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default PageTab;